import React from 'react';
import {Card} from 'antd';
import "./PlansAfterSchool.css";

const PlansAfterSchool = () => {
    return (
        <Card>
            <div className="pas-container">
                <h2 className="pas-header">PART A (4) - Plans After School</h2>

                <div className="pas-bigstep">The next big step of my life</div>

                <p className="pas-after-school">After I finish school, I want to...</p>
                <div className="pas-options-container">
                    <label className="pas-option-label">
                        <input type="checkbox"/> Go to college for a general education
                    </label>
                    <label className="pas-option-label">
                        <input type="checkbox"/> Take up a vocation full time
                    </label>
                    <label className="pas-option-label">
                        <input type="checkbox"/> Prepare for my next step for admission in a professional
                        institute/college
                    </label>
                    <label className="pas-option-label">
                        <input type="checkbox"/> Any other, please specify
                        <input type="text" className="pas-option-text"/>
                    </label>
                </div>

                <div className="pas-plan-container">
                    <div className="pas-college-container">
                        <strong>I plan to go to college/vocational institute/professional institute</strong>
                        <label className="pas-college-label">College/Vocational Institute/Professional
                            Institute:</label>
                        <input type="text" className="pas-college-input"/>
                        <label className="pas-college-label">Course/Skill Training:</label>
                        <input type="text" className="pas-college-input"/>
                        <label className="pas-college-label">Type of Course:</label><br/>
                        <input type="checkbox"/> Certificate
                        <input type="checkbox"/> Diploma
                        <input type="checkbox"/> Degree
                    </div>

                    <div className="pas-vocation-container">
                        <strong>I plan to pursue a vocation. I would like to work...</strong>
                        <label className="pas-vocation-label"><input type="checkbox"/> In a corporation or private
                            business</label>
                        <label className="pas-vocation-label"><input type="checkbox"/> In my own business</label>
                        <label className="pas-vocation-label"><input type="checkbox"/> In my family business</label>
                        <label className="pas-vocation-label"><input type="checkbox"/> In government</label>
                        <label className="pas-vocation-label"><input type="checkbox"/> Any other <input type="text"
                                                                                                        className="pas-vocation-input"/></label>
                    </div>
                </div>

                <p className="pas-discuss">Please discuss the following with your
                    teacher/counselor/parent/caregiver/peer.</p>

                <table className="pas-discuss-table">
                    <tr>
                        <th className="pas-discuss-th">What strengths or abilities will be most helpful for you in
                            fulfilling this plan?
                        </th>
                        <th className="pas-discuss-th">What will you need to improve in order to achieve this plan?</th>
                        <th className="pas-discuss-th">What challenges do you think you will face in fulfilling this
                            plan?
                        </th>
                    </tr>
                    <tr>
                        <td><textarea className="pas-discuss-textarea"></textarea></td>
                        <td><textarea className="pas-discuss-textarea"></textarea></td>
                        <td><textarea className="pas-discuss-textarea"></textarea></td>
                    </tr>
                </table>

                <h2 className="fs-header">
                    &#x1f4c5; Let’s imagine your ‘Future Self,’ 10 years from now...
                </h2>

                <table className="fs-table">
                    <tr>
                        <th className="fs-th">What will you be doing to <span
                            className="fs-span-orange">improve</span> yourself?
                        </th>
                        <th className="fs-th">What will you be doing to <span
                            className="fs-span-blue">support</span> your friends and family?
                        </th>
                        <th className="fs-th">What will you be doing to <span
                            className="fs-span-orange">improve</span> society?
                        </th>
                    </tr>
                    <tr>
                        <td><textarea className="fs-textarea"></textarea></td>
                        <td><textarea className="fs-textarea"></textarea></td>
                        <td><textarea className="fs-textarea"></textarea></td>
                    </tr>
                </table>

                <h3 className="fs-subheader">How do I feel about my future?</h3>

                <p><strong>Circle as applicable.</strong></p>
                <div className="fs-range-container">
                    <div>Prepared <input type="range" min="1" max="10" step="1" className="fs-range-input"/></div>
                    <div>Excited <input type="range" min="1" max="10" step="1" className="fs-range-input"/></div>
                    <div>Confident <input type="range" min="1" max="10" step="1" className="fs-range-input"/></div>
                    <div>Curious <input type="range" min="1" max="10" step="1" className="fs-range-input"/></div>
                </div>

                <div className="fs-feedback-container">
                    <div className="fs-feedback-box">
                        <h4 className="fs-feedback-header">Why do you think so?</h4>
                        <textarea className="fs-feedback-textarea"></textarea>
                    </div>
                    <div className="fs-feedback-box">
                        <h4 className="fs-feedback-header">Parents’ feedback</h4>
                        <textarea className="fs-feedback-textarea"></textarea>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default PlansAfterSchool;